import { IonButton, IonIcon, IonModal } from "@ionic/react";

import "./SecurityModal.css";
import { arrowForwardOutline, checkmarkCircleOutline } from "ionicons/icons";
import { useHistory } from "react-router-dom";
import SecurityImage from "../assets/image/security.png";
interface SecurityModalProps {
  isOpen: boolean;
  setOpen: (value: boolean) => void;
  nextUrl: string;
}

const SecurityModal: React.FC<SecurityModalProps> = ({
  isOpen,
  setOpen,
  nextUrl,
}) => {
  const history = useHistory();
  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={() => setOpen(false)}
      className="SecurityModal-modal"
    >
      <div className="SecurityModal">
        <div className="SecurityModal-header">
          <div className="SecurityModal-header-image">
            <img src={SecurityImage} alt="Security" />
          </div>
          <div className="SecurityModal-header-title">
            Les accidents du travail liés à la montée-descente du véhicule
          </div>
        </div>
        <div className="SecurityModal-content">
          <div className="SecurityModal-content-text">
            <IonIcon
              src={checkmarkCircleOutline}
              className="SecurityModal-content-text-icon"
            />
            Accès-descente de la cabine
          </div>
          <ul className="SecurityModal-content-list">
            <li className="SecurityModal-content-list-item">
              1/3 des accidents
            </li>
            <li className="SecurityModal-content-list-item">
              Foulures, fractures, entorses
            </li>
          </ul>
          <div className="SecurityModal-content-text">
            <IonIcon
              src={checkmarkCircleOutline}
              className="SecurityModal-content-text-icon"
            />
            Accès arrière et latéral
          </div>
          <div className="SecurityModal-content-text">
            <IonIcon
              src={checkmarkCircleOutline}
              className="SecurityModal-content-text-icon"
            />
            Accès aux têtes d’accouplement et aux équipements
          </div>
          <div className="SecurityModal-content-text">
            <IonIcon
              src={checkmarkCircleOutline}
              className="SecurityModal-content-text-icon"
            />
            Accès aux dômes des citernes
          </div>
          <div className="SecurityModal-content-text">
            <IonIcon
              src={checkmarkCircleOutline}
              className="SecurityModal-content-text-icon"
            />
            Accès en fond de benne
          </div>
          <div className="SecurityModal-content-text">
            <IonIcon
              src={checkmarkCircleOutline}
              className="SecurityModal-content-text-icon"
            />
            Règles des 3 points d’appui : Alternativement :
          </div>
          <ul className="SecurityModal-content-list">
            <li className="SecurityModal-content-list-item">
              2 pieds en appui et 1 main en prise
            </li>
            <li className="SecurityModal-content-list-item">
              2 mains en prise et 1 pied en appui
            </li>
          </ul>
        </div>
        <div className="SecurityModal-footer">
          <IonButton
            color="success"
            routerDirection="forward"
            className="InspectionFooter-button"
            onClick={() => {
              setOpen(false);
              history.push(nextUrl);
            }}
          >
            J'ai bien pris connaissance de l'information{" "}
            <IonIcon icon={arrowForwardOutline} slot="end" />
          </IonButton>
        </div>
      </div>
    </IonModal>
  );
};

export default SecurityModal;
